/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class StockOutApi {
    static getInstance() {
        if (!this.instance) this.instance = new StockOutApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取发货出库列表
    async getStockOutList (param,num,size){
        let url = `/api/order/stock/out/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取退货、换货、补寄的出库列表
    async getOutList (param,num,size){
        let url = `/api/order/back/record/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 签收 
    async signFor (param,id){
        let url = `/api/order/stock/out/${id}/sign`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取仓库下拉
    async getWarehouse(){
        let url = `/api/order/warehouse`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取物流公司下拉
    async getCourierType (param,id){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 出库时获取物流ID
    async getCourierId(param){
        let url = `/api/courier/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取产品列表
    async getProductList (param){
        let url = `/api/product/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取下出库单整车数量
    async getBikeCount (param){
        let url = `/api/order/stock/out/count`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取未出库整车数量
    async getUnoutboundCount (param){
        let url = `/api/order/stock/out/count`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取已出库整车数量
    async getOutboundCount (param){
        let url = `/api/order/stock/out/count`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 编辑出库信息
    async editStock (param,id){
        let url = `/api/order/stock/out/${id}/update/courier`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 编辑退货、换货、补寄、返修物流信息
    async editBackCurrier (param,id){
        let url = `/api/order/back/record/${id}/update`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 编辑车架号
    async editFrameNumber (param,id){
        let url = `/api/order/stock/out/${id}/vehicle`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取用户信息
    async getCustomer(id){
        let url = `/api/customer/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 保存发货备注信息
    async saveComment(id,param){
        let url = `/api/order/stock/out/${id}/instruction`
        let result = await this.getData(url,param,'GET')
        return result
    }

     // 保存退货、换货、补寄备注信息
     async saveReturnComment(id,param){
        let url = `/api/order/back/record/${id}/instruction`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取订单金额
    async getAmount(id){
        let url = `/api/order/head/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取客户列表
    // async getCustomerList (param){
    //     let url = `/api/customer/query`
    //     let result = await this.getData(url,param,'POST')
    //     return result
    // }

    async getCustomerList (param){
        let url = `/api/customer/entity/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 取消出库单
    async cancelOutbound (param){
        let url = `/api/order/stock/out/cancel?delivery_number=${param.delivery_number}&order_type=${param.order_type}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 取消退货单
    async cancelReturn (id){
        let url = `/api/order/back/record/cancel/back/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 取消换货单
    async cancelSwap (id){
        let url = `/api/order/back/record/cancel/swap/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 取消补寄单
    async cancelReissue (id){
        let url = `/api/order/back/record/cancel/reissue/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 导出出库单
    async exportFile (param){
        let url = `/api/order/stock/out/export/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 
    

    // ZU导出出库单
    async zuExportFile (param){
        let url = `/api/order/stock/out/export/warehouse/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 给zu发送出货邮件
    async sendEmailToZU (param){
        let url = `/api/order/stock/out/zu/unoutbound`
        let result = await this.getData(url,param,'GET')
        return result
    } 

    // 导出退货单
    async exportReturn (param){
        let url = `/api/order/back/record/export/return`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 导出换货单
    async exportExchange (param){
        let url = `/api/order/back/record/export/exchange`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 导出补寄单
    async exportReissue (param){
        let url = `/api/order/back/record/export/reissue`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 导出返修单
    async exportReturnFactory (param){
        let url = `/api/order/back/record/export/factory`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 导出
    async separateExportFile (param){
        let url = `/api/order/stock/out/export/separate/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 获取用户
    async getUser(){
        let url = `/api/user/query`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // 获取未出库的整车和bom数量
    async getUnoutboundBikeBomCount(param){
        let url = `/api/order/stock/out/unoutbound`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取未退货/未换货/未补寄的整车和bom数量
    async getBackUnoutboundBikeBomCount(param){
        let url = `/api/order/back/record/unoutbound`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取bom类别
    async getBomCategory(){
        // let url = `/api/product/bom/category` 
        let url = `/api/product/category`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取bom类别
    async getCategory (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 下载发货单 
    // async downloadDeliveryNote(order_name,param){
    //     let url = `/api/invoice/download/delivery/${order_name}`
    //     let result = await this.getData(url,param,'GET')
    //     return result
    // }

    // 删除发货单 
    // async deleteDeliveryNote(param){
    //     let url = `/api/invoice/remove/${param.order_number}?order_number=${param.order_number}&invoice_type=${param.invoice_type}`
    //     let result = await this.getData(url,{},'DELETE')
    //     return result
    // }

    // 发送发货单 （发货单）
    async sendDeliveryNote(param){
        let url = `/api/order/module/email/delivery?order_number=${param.order_number}&delivery_number=${param.delivery_number}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 发送发货单 （补寄单）
    async sendReissueDeliveryNote(param){
        let url = `/api/order/module/email/reissue/delivery`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取订单详情 
    async getShipDetail(param){
        let url = `/api/order/head/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取发货记录
    async getDeliverRecord(param){
        let url = `/api/order/stock/out/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 校验送货单是否二次发送
    async vaildDeliveryNoteSendCount(param){
        let url = `/api/invoice/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 下载补寄发货单  
    async downloadDeliveryNote(param, order_name){
        let url = `/api/invoice/download/delivery/${order_name}`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 下载补寄发货单  
    async downloadReissueNote(param, order_name){
        let url = `/api/invoice/download/reissue/delivery/${order_name}`
        let result = await this.getData(url,param,'GET')
        return result
    }
}

export {
    StockOutApi
}